import { render, staticRenderFns } from "./LandingComoListItem.vue?vue&type=template&id=39abdc51"
import script from "./LandingComoListItem.vue?vue&type=script&lang=js"
export * from "./LandingComoListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports